import {
    useLocalParticipant, useTrackTranscription
} from "@livekit/components-react";
import { Track } from "livekit-client";
import { useEffect, useMemo, useCallback } from "react";
import PropTypes from 'prop-types';
import { MethodName, UnityObjectName } from "../../utils/const";

export function TranscriptionTile({ sendMessage, agentAudioTrack }) {
    const agentMessages = useTrackTranscription(agentAudioTrack);
    const localParticipant = useLocalParticipant();

    const localMessages = useTrackTranscription({
        publication: localParticipant.microphoneTrack,
        source: Track.Source.Microphone,
        participant: localParticipant.localParticipant,
    });

    // Memoized function to send messages to Unity, only sends when content changes
    const sendMessageToUnity = useCallback((text, agentname, isfinal, id) => {
        const msg = JSON.stringify({ text, agentname, isfinal, id });
        sendMessage(UnityObjectName, MethodName, msg);
    }, [sendMessage]);

    // Memoize agent messages to process only new segments
    const agentSegments = useMemo(() => agentMessages.segments, [agentMessages.segments]);
    useEffect(() => {
        if (agentSegments.length === 0) return;  // Skip if no new segments
        agentSegments.forEach((s) => {
            console.log("Sending Agent Transcript:", {
                id: s.id,
                text: s.text,
                final: s.final,
                participant: "tutor",
                timestamp: s.lastReceivedTime
            });
            sendMessageToUnity(s.text, "TUTOR", s.final, s.id);
        });
    }, [agentSegments, sendMessageToUnity]);

    // Memoize local participant messages to process only new segments
    const localSegments = useMemo(() => localMessages.segments, [localMessages.segments]);
    useEffect(() => {
        if (localSegments.length === 0) return;  // Skip if no new segments
        localSegments.forEach((s) => {
            console.log("Sending Local Transcript:", {
                id: s.id,
                text: s.text,
                final: s.final,
                participant: "player",
                timestamp: s.lastReceivedTime
            });
            sendMessageToUnity(s.text, "ME", s.final, s.id);
        });
    }, [localSegments, sendMessageToUnity]);

    return null;
}

TranscriptionTile.propTypes = {
    sendMessage: PropTypes.func.isRequired,
    agentAudioTrack: PropTypes.object.isRequired,
};
